import { Persone_List_Interface } from "./Persone_List_Interface"

export interface Chart_Interface {
    id:number,
    title:String,
    dsc:String,
    src:String,
    parent:number,
    haghOzviayt:number,
    positionGrid:number,
    subdate:String,
    username: String,
    child: Array<Chart_Interface>,
    person: Array<Persone_List_Interface>,
    childVisible:boolean
  }
  
  export function Empty_Chart_Interface():Chart_Interface{
    return{
      id:0,
      title:'',
      dsc:'',
      src:'',
      parent:0,
      haghOzviayt:0,
      positionGrid:0,
      subdate:'',
      username:'',
      child: [],
      person: [],
      childVisible:true
    }
  }
  